import { computed } from 'vue';

import { hasPermission } from '@/shared/helpers/permissions.helpers';

import type { IContactSummaryContact } from './contact-summary.helpers';

// Kept apart from contact-summary.helpers.ts: hasPermission pulls in `@/global`, which the pure
// helpers must not (they stay safe to import from lean bundles).

/** Which parts of a contact summary the current user may see (mirrors the server's gating). */
export const contactSummaryAccess = computed(() => ({
    spend: hasPermission('crm', 'spendRead'),
    lastSale: hasPermission('sales', 'transactionsView'),
    bookings: hasPermission('sales', 'bookingsViewAll')
}));

export const canLoadContactSummaries = computed(() => {
    const a = contactSummaryAccess.value;
    return a.spend || a.lastSale || a.bookings;
});

/** Stable string for change detection (permissions changed → cached summaries are invalid). */
export const contactSummaryAccessKey = computed(() => {
    const a = contactSummaryAccess.value;
    return `${+a.spend}${+a.lastSale}${+a.bookings}`;
});

/**
 * Hover-card gate: any Sales/spend grant, or notes access on a contact flagged with alerts (so a
 * notes-only viewer never gets a card holding nothing but the name).
 */
export function canOpenContactCard(contact: IContactSummaryContact | string): boolean {
    if (canLoadContactSummaries.value) return true;
    return typeof contact !== 'string' && contact.hasAlerts === true && hasPermission('crm', 'notesRead');
}
